<div style="margin:10px">
	<div class="row jmPageTitle" style="margin-bottom: 30px;">
		<div class=" col-sm-12 ">
			<span style="float:left;">
				History
			</span>
			<div style="float:right;">
				<span>
					<span (click)="clearHistory()" role="button" class="pgn-text text-primary">Clear History</span> &nbsp;
					<span (click)="closeModal()" role="button" class="jmCloseBtn"></span>
				</span>
			</div>
		</div>
	</div>
	<div class="jmWidgetPadding modal-content" style="padding-top: 0!important; background-color:#F5F5F5;">
		<mat-dialog-content>
			<div *ngFor="let dateItem of dateItems">
				<div class="history-view-all-date">{{getDate(dateItem.date)}}</div>

				<div class="card" style="margin: 0; margin-bottom: 4px;" *ngFor="let historyEntry of dateItem.historyEntries">
					<div class="panel-heading" style="padding-top: 15px; padding-bottom: 15px; padding-left: 20px; padding-right: 20px;">
						<div style="white-space: normal; overflow: hidden; text-overflow: ellipsis; line-height: 30px;" class="ng-binding">
							<div style="display: inline-block; margin-right: 10px; font-size: 16px;">{{historyEntry.ellipsisEntry.headerName}}</div>
							<ul style="padding: 0; display: inline;">
								<li *ngFor="let link of historyEntry.ellipsisEntry.links; last as isLast;" style="display:inline-block; list-style: none; white-space:nowrap;">
									<a href="javascript:void(0)" (click)="ellipsisClick(historyEntry.ellipsisEntry, link.linkUrl)" class="text-primary" style="padding: 0px 5px;">{{link.linkName}}</a>
									<span *ngIf="!isLast && historyEntry.ellipsisEntry.links.length > 1" style="color:rgba(52, 73, 94, 0.75)">&gt; &nbsp;</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</mat-dialog-content>
	</div>
	<div *ngIf="totalItems > itemsPerPage || curPage > 0" class="text-center" style="margin-top: 30px">
		<!-- pagination -->
		<div role="button" class="text-primary" (click)="decPage()" [ngClass]="(curPage===0) ? 'pgn-text-disabled' : 'pgn-text'">Previous</div>
		<div style="display: inline-block;  width: 10rem;"></div>
		<div role="button" class="text-primary" (click)="incPage()" [ngClass]="(endReached===true) ? 'pgn-text-disabled' : 'pgn-text'">Next</div>
	</div>
</div>
